import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SUBJECT_FIELD: `${cleanedFilename(__filename)}-subject-field`,
  BODY_FIELD: `${cleanedFilename(__filename)}-body-field`,
  TARGET_INPUT_FIELD: `${cleanedFilename(__filename)}-target-input-field`,
};
